import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box,HelpIcon, useResponsive } from '@common-fe/common-fe';

import ClaimWarningCard, { ActionButtonType } from '@/modules/UseMyMoney/widgets/UseMyMoneySummary/components/ClaimWarningCard/ClaimWarningCard';

import WhyDoesItMatterModal from '../WhyDoesItMatterModal/WhyDoesItMatterModal';

interface Props {
  onUpload: () => void;
}

const OcrScanFailedWarning: React.FC<Props> = ({ onUpload }) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  const [isWhyModalVisible, setIsWhyModalVisible] = useState(false);

  return (
    <>
      <ClaimWarningCard
        testId="ocr-scan-failed-warning"
        title={t('Are the missing details on your document?')}
        description={t(
          'We were unable to find all the details on the document uploaded. To receive your money faster, upload a clearer photo or a different document including the missing details. If you do not have another document, you can add the missing details below.'
        )}
        actionsGap={isMobile ? '2px' : 'spacing12'}
        actions={[
          {
            label: t('Upload a New Document'),
            testId: 'ocr-scan-failed-warning_upload-btn',
            onClick: onUpload,
            isFlexible: isMobile,
            height: isMobile ? '40px' : undefined,
          },
          {
            label: isMobile ? undefined : t('Why Does It Matter?'),
            icon: isMobile ? (
              <Box align="center" justify="center" pad="8px" style={{ width: '40px', height: '40px' }}>
                <HelpIcon size="24px" color="iconPrimary" />
              </Box>
            ) : undefined,
            testId: 'ocr-scan-failed-warning_why-btn',
            buttonType: ActionButtonType.LINK,
            onClick: () => setIsWhyModalVisible(true),
          },
        ]}
      />

      {isWhyModalVisible && <WhyDoesItMatterModal onClose={() => setIsWhyModalVisible(false)} />}
    </>
  );
};

export default OcrScanFailedWarning;
